import { render } from "./SetNotice.vue?vue&type=template&id=d44fa1c4&scoped=true"
import script from "./SetNotice.vue?vue&type=script&lang=js"
export * from "./SetNotice.vue?vue&type=script&lang=js"

import "./SetNotice.vue?vue&type=style&index=0&id=d44fa1c4&scoped=true&lang=css"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44fa1c4"]])

export default __exports__